import { render } from "./NPrograms.vue?vue&type=template&id=3ebd199c"
import script from "./NPrograms.vue?vue&type=script&lang=js"
export * from "./NPrograms.vue?vue&type=script&lang=js"

import "./NPrograms.vue?vue&type=style&index=0&id=3ebd199c&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__